<head>
  <title></title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="quick-access-container">
  <div class="position-relative grid-content">
    <div>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center px-3">
          <div class="dropdown">
          </div>
        </div>
        <div class="d-flex gap-3">
          <div id="header-container">
            <div class="">
              <div class="search-container">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="text" class="form-control search_input" style="font-size: 12px"
                  placeholder="Search here..." [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-container">
      <table class="dynamic-table-container" aria-describedby="table-description">
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th id="grid-header-container" *ngFor="let columnData of columnLists.fieldColumnarray; let ix = index;"
          [ngStyle]="{'min-width': columnData.width,'max-width': columnData.width,'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{ columnData.fieldColumnarray }}</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn(columnLists.columnsListarray[ix],columnData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div>
              <!-- <div>
                                <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px"
                                    alt="filter" />
                            </div> -->
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
          </div>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
        <tr *ngFor="let list of pagedItems let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" (click)="navigate(list)">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{ list[key.columnsListarray]
              }}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-template ActivityPage"
  *ngIf="this.qualityService.taskModuleName=='AU' && (this.qualityService.auditEditmodeDatas.pageName=='Annual Audit Schedule'|| this.qualityService.auditEditmodeDatas.pageName=='Audit Plan')"
  id="Actions" style="margin-top:1%;">
  <app-au [activityData]="false"></app-au>
</div>

<ng-template #addPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-6">
          <div><label id="checkRequiredFor-validation" for="email">Check Required For</label><span
              class="mandatory-symbol">*</span></div>
          <ng-multiselect-dropdown id="checkRequiredFor" class="multiselect-container"
            style="position: absolute; width: 45%;" [(ngModel)]="selectedCheckRequiredFor"
            [settings]="singleSelectDropdownSetting" [data]="checkRequiredForListDropdown"
            (onSelect)="onCheckRequiredForSelect($event)" (onDeSelect)="onCheckRequiredForRemoved($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="col-md-6">
          <div><label id="ownerField-validation" for="email">Owner</label><span class="mandatory-symbol">*</span></div>
          <ng-multiselect-dropdown id="owner" class="multiselect-container" style="position: absolute; width: 45%;"
            [(ngModel)]="selectedOwner" [settings]="singleSelectDropdownSetting" [data]="ownerListDropdown"
            (onSelect)="onOwnerSelect($event)" (onDeSelect)="onOwnerRemoved($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="row" style="margin-top: 6%;">
        <div class="col-md-6">
          <div><label id="dueDate-validation" for="email">Due Date</label><span class="mandatory-symbol">*</span></div>
          <input id="dueDate" class="form-control data-picker-continer" type="text" bsDatepicker
            [bsConfig]="dueDatePickerConfiguration" [dateCustomClasses]="datepickerDateCustomClasses"
            [(ngModel)]="ecData.dueDate" (ngModelChange)="dueDateOnChanged($event)">
        </div>
        <div class="col-md-6">
          <div><label for="email">Remind N Days Before Due Date</label></div>
          <input class="input-filed-continers" type="number" id="remindNDaysBeforeDueDate"
            (keydown)="validateNumberFields($event)" [(ngModel)]="ecData.remindNDaysBeforeDueDate">
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="addFunction(ecData)">
        <i class="fas fa-plus"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelAddPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmFindingPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFindings()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <app-au-finding-details></app-au-finding-details>
  </div>
</ng-template>
